import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DSButton, DSIcon } from '../design-system/primitives';
import './NotFound.css';

const NotFound = ({ isAuthenticated }) => {
  const navigate = useNavigate();

  const handlePrimary = () => {
    if (isAuthenticated) {
      navigate('/my-membership');
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="not-found-icon"><DSIcon name="search" /></div>
        <h1>Page Not Found</h1>
        <p>We could not find the page you were looking for.</p>
        <p className="not-found-hint">
          Check the URL or use the button below to get back on track.
        </p>
        <div className="not-found-actions">
          <DSButton appearance="solid" tone="primary" onClick={handlePrimary}>
            {isAuthenticated ? 'Go to My Account' : 'Go to Login'}
          </DSButton>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
